/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Multisensors_ListInputs */



/**
* | output |
* | --- |
* | "Multisensor list" |
*
* @param {Multisensors_ListInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const multisensors_list = /** @type {((inputs?: Multisensors_ListInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Multisensors_ListInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Multisensor list")
	return /** @type {LocalizedString} */ ("Liste des multicapteurs")
});